import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Switch,
} from '@material-ui/core';
import { updateSchoolAsync } from '../bccTeenybeansStore/bccTeenybeansStoreSlice';
import { toast } from 'react-toastify';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import style from '../formik.module.css';

const UpdateSchool = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { schoolData } = useSelector((state) => {
    const { teenybeansReducer } = state;
    return {
      schoolData: teenybeansReducer.allSchool
        ? teenybeansReducer.allSchool && teenybeansReducer.allSchool.data
        : [],
    };
  });

  const location = useLocation();
  const branchUniqueId = location.search.split('=');

  const singleSchoolData =
    schoolData && schoolData.find((o) => o._id === branchUniqueId[1]);

  const accessData =
    singleSchoolData &&
    singleSchoolData.moduleAccess &&
    singleSchoolData.moduleAccess;

  const [moduleAccess, setModuleAccess] = useState({
    DASHBOARD: accessData && accessData.DASHBOARD,
    DIGITAL_DELIVERABLES: accessData && accessData.DIGITAL_DELIVERABLES,
    METHODOLOGY_TRAINING: accessData && accessData.METHODOLOGY_TRAINING,
    ROI: accessData && accessData.ROI,
    SCHOOL_DOCUMENTS: accessData && accessData.SCHOOL_DOCUMENTS,
    TEAMS: accessData && accessData.TEAMS,
    AKADMY: accessData && accessData.AKADMY,
    WEBSITE_BUILDER: accessData && accessData.WEBSITE_BUILDER,
  });

  const mobile = singleSchoolData && singleSchoolData.phone.split('-');
  const date = singleSchoolData && singleSchoolData.expiryDate.split('T');

  const initialValues = {
    name: singleSchoolData && singleSchoolData.name,
    email: singleSchoolData && singleSchoolData.email,
    phone: mobile && mobile[1],
    expiryDate: date && date[0],
  };

  const [status, setStatus] = useState(
    singleSchoolData && singleSchoolData.isActive
  );

  return (
    <>
      {
        <div>
          <Box mt={-4} style={{ float: 'right' }}>
            <Link to={`/teenybeans-portal`}>
              <Button
                variant="outlined"
                disableElevation
                size="large"
                color="primary">
                Back
              </Button>
            </Link>
          </Box>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Box border="1px solid #dfdfdf" p={3}>
                  <Box mb={3} fontSize={22} fontWeight={'fontWeightSmall'}>
                    School Update{status}
                    <Switch
                      color="primary"
                      value={status}
                      checked={status}
                      onChange={(e) => setStatus(e.target.checked)}
                    />
                  </Box>
                  <Formik
                    initialValues={initialValues}
                    onSubmit={async (values) => {
                      await new Promise((r) => setTimeout(r, 500));

                      const payload = {
                        // ...values,
                        // phone: `+91-${values.phone}`,
                        // moduleAccess: moduleAccess,
                      };

                      if (singleSchoolData.isActive !== status) {
                        payload.isActive = status;
                      }

                      if (singleSchoolData.name !== values.name) {
                        payload.name = values.name;
                      }
                      if (singleSchoolData.email !== values.email) {
                        payload.email = values.email;
                      }
                      if (singleSchoolData.email !== values.email) {
                        payload.email = values.email;
                      }
                      if (singleSchoolData.phone !== `+91-${values.phone}`) {
                        payload.phone = `+91-${values.phone}`;
                      }
                      if (date && date[0] !== values.expiryDate) {
                        payload.expiryDate = values.expiryDate;
                      }
                      if (
                        JSON.stringify(moduleAccess) !==
                        JSON.stringify(accessData)
                      ) {
                        payload.moduleAccess = moduleAccess;
                      }

                      if (values.phone.match(/^\d{10}$/)) {
                        dispatch(
                          updateSchoolAsync({
                            id: branchUniqueId[1],
                            data: payload,
                          })
                        )
                          .unwrap()
                          .then((res) => {
                            if (res && res.data && res.data._id !== '') {
                              toast.success('School updated Successfully');
                              history.push('/teenybeans-portal');
                            }
                          })
                          .catch((err) => {
                            toast.error(err.message);
                          });
                      } else {
                        toast.error('Enter 10 digit phone number');
                      }
                    }}>
                    {({ values, setFieldValue }) => (
                      <Form>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <label>School name</label>
                            <Field
                              className={style.field}
                              type="text"
                              id="name"
                              name="name"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <label>Phone</label>
                            <Field
                              className={style.field}
                              type="tel"
                              // id="phone"
                              name="phone"
                            />
                            <ErrorMessage name="phone" component="div" />
                          </Grid>
                          <Grid item xs={6}>
                            <label>Email address</label>
                            <Field
                              className={style.field}
                              type="email"
                              id="email"
                              name="email"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <label>Valid till</label>
                            <Field
                              className={style.field}
                              type="date"
                              id="expiryDate"
                              name="expiryDate"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <label>Manage access</label>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={moduleAccess.DASHBOARD}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: e.target.checked,
                                      DIGITAL_DELIVERABLES:
                                        moduleAccess.DIGITAL_DELIVERABLES,
                                      METHODOLOGY_TRAINING:
                                        moduleAccess.METHODOLOGY_TRAINING,
                                      ROI: moduleAccess.ROI,
                                      SCHOOL_DOCUMENTS:
                                        moduleAccess.SCHOOL_DOCUMENTS,
                                      TEAMS: moduleAccess.TEAMS,
                                      AKADMY: moduleAccess.AKADMY,
                                      WEBSITE_BUILDER:
                                        moduleAccess.WEBSITE_BUILDER,
                                    })
                                  }
                                  name="Dashboard"
                                />
                              }
                              label="Dashboard"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={moduleAccess.DIGITAL_DELIVERABLES}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: moduleAccess.DASHBOARD,
                                      DIGITAL_DELIVERABLES: e.target.checked,
                                      METHODOLOGY_TRAINING:
                                        moduleAccess.METHODOLOGY_TRAINING,
                                      ROI: moduleAccess.ROI,
                                      SCHOOL_DOCUMENTS:
                                        moduleAccess.SCHOOL_DOCUMENTS,
                                      TEAMS: moduleAccess.TEAMS,
                                      AKADMY: moduleAccess.AKADMY,
                                      WEBSITE_BUILDER:
                                        moduleAccess.WEBSITE_BUILDER,
                                    })
                                  }
                                  name="Digital Delivarables"
                                />
                              }
                              label="Digital Delivarables"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={moduleAccess.METHODOLOGY_TRAINING}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: moduleAccess.DASHBOARD,
                                      DIGITAL_DELIVERABLES:
                                        moduleAccess.DIGITAL_DELIVERABLES,
                                      METHODOLOGY_TRAINING: e.target.checked,
                                      ROI: moduleAccess.ROI,
                                      SCHOOL_DOCUMENTS:
                                        moduleAccess.SCHOOL_DOCUMENTS,
                                      TEAMS: moduleAccess.TEAMS,
                                      AKADMY: moduleAccess.AKADMY,
                                      WEBSITE_BUILDER:
                                        moduleAccess.WEBSITE_BUILDER,
                                    })
                                  }
                                  name="Methodology Training"
                                />
                              }
                              label="Methodology Training"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={moduleAccess.ROI}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: moduleAccess.DASHBOARD,
                                      DIGITAL_DELIVERABLES:
                                        moduleAccess.DIGITAL_DELIVERABLES,
                                      METHODOLOGY_TRAINING:
                                        moduleAccess.METHODOLOGY_TRAINING,
                                      ROI: e.target.checked,
                                      SCHOOL_DOCUMENTS:
                                        moduleAccess.SCHOOL_DOCUMENTS,
                                      TEAMS: moduleAccess.TEAMS,
                                      AKADMY: moduleAccess.AKADMY,
                                      WEBSITE_BUILDER:
                                        moduleAccess.WEBSITE_BUILDER,
                                    })
                                  }
                                  name="ROI"
                                />
                              }
                              label="ROI"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={moduleAccess.SCHOOL_DOCUMENTS}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: moduleAccess.DASHBOARD,
                                      DIGITAL_DELIVERABLES:
                                        moduleAccess.DIGITAL_DELIVERABLES,
                                      METHODOLOGY_TRAINING:
                                        moduleAccess.METHODOLOGY_TRAINING,
                                      ROI: moduleAccess.ROI,
                                      SCHOOL_DOCUMENTS: e.target.checked,
                                      TEAMS: moduleAccess.TEAMS,
                                      AKADMY: moduleAccess.AKADMY,
                                      WEBSITE_BUILDER:
                                        moduleAccess.WEBSITE_BUILDER,
                                    })
                                  }
                                  name="School Document"
                                />
                              }
                              label="School Document"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={moduleAccess.TEAMS}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: moduleAccess.DASHBOARD,
                                      DIGITAL_DELIVERABLES:
                                        moduleAccess.DIGITAL_DELIVERABLES,
                                      METHODOLOGY_TRAINING:
                                        moduleAccess.METHODOLOGY_TRAINING,
                                      ROI: moduleAccess.ROI,
                                      SCHOOL_DOCUMENTS:
                                        moduleAccess.SCHOOL_DOCUMENTS,
                                      TEAMS: e.target.checked,
                                      AKADMY: moduleAccess.AKADMY,
                                      WEBSITE_BUILDER:
                                        moduleAccess.WEBSITE_BUILDER,
                                    })
                                  }
                                  name="Teams"
                                />
                              }
                              label="Teams"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={moduleAccess.AKADMY}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: moduleAccess.DASHBOARD,
                                      DIGITAL_DELIVERABLES:
                                        moduleAccess.DIGITAL_DELIVERABLES,
                                      METHODOLOGY_TRAINING:
                                        moduleAccess.METHODOLOGY_TRAINING,
                                      ROI: moduleAccess.ROI,
                                      SCHOOL_DOCUMENTS:
                                        moduleAccess.SCHOOL_DOCUMENTS,
                                      TEAMS: moduleAccess.TEAMS,
                                      AKADMY: e.target.checked,
                                      WEBSITE_BUILDER:
                                        moduleAccess.WEBSITE_BUILDER,
                                    })
                                  }
                                  name="Akadmy"
                                  color="primary"
                                />
                              }
                              label="Akadmy"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={moduleAccess.WEBSITE_BUILDER}
                                  onChange={(e) =>
                                    setModuleAccess({
                                      DASHBOARD: moduleAccess.DASHBOARD,
                                      DIGITAL_DELIVERABLES:
                                        moduleAccess.DIGITAL_DELIVERABLES,
                                      METHODOLOGY_TRAINING:
                                        moduleAccess.METHODOLOGY_TRAINING,
                                      ROI: moduleAccess.ROI,
                                      SCHOOL_DOCUMENTS:
                                        moduleAccess.SCHOOL_DOCUMENTS,
                                      TEAMS: moduleAccess.TEAMS,
                                      AKADMY: moduleAccess.AKADMY,
                                      WEBSITE_BUILDER: e.target.checked,
                                    })
                                  }
                                  name="Website Builder"
                                  color="primary"
                                />
                              }
                              label="Website Builder"
                            />
                          </Grid>
                        </Grid>
                        <Box mt={2} />
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Box mt={1} />
                            <Button
                              disabled={
                                values.name === '' ||
                                values.email === '' ||
                                values.phone === '' ||
                                values.expiryDate === ''
                              }
                              variant="contained"
                              color="primary"
                              type="submit">
                              Update
                            </Button>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      }
    </>
  );
};

export default UpdateSchool;
